import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import AlertSnackbar from 'bento-ordering/base/components/Snackbar/AlertSnackbar';
import {
  SnackbarTitle,
  SnackbarMessage
} from 'bento-ordering/base/components/Snackbar/SnackbarTypography';
import { isMobileMedia } from 'bento-ordering/utils/media';
import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_ITEM_NAMES
} from 'styles/constants/appearanceSectionNames';

const Message = ({ itemQuantity }) => {
  const titleStyles = { variant: MENU_ITEM_NAMES };
  const messageStyles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <span>
      <Box pb={1}>
        <SnackbarTitle component="p" {...titleStyles}>
          <strong>
            {`${itemQuantity} ${
              itemQuantity < 2 ? 'item' : 'items'
            } added to your order!`}
          </strong>
        </SnackbarTitle>
      </Box>
      <SnackbarMessage component="p" {...messageStyles}>
        See if we can deliver to you, or switch to pickup.
      </SnackbarMessage>
    </span>
  );
};

const NoSetAddressSnackbar = ({ open, onClose, metaData }) => {
  const itemQuantity = metaData.latestItemQuantity;

  return (
    <AlertSnackbar
      onClose={onClose}
      open={open}
      message={Message({ itemQuantity })}
      vertical={isMobileMedia() ? 'bottom' : 'top'}
    />
  );
};

NoSetAddressSnackbar.defaultProps = {
  open: false,
  onClose: () => {},
  metaData: {}
};

NoSetAddressSnackbar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  metaData: PropTypes.object
};

Message.propTypes = {
  itemQuantity: PropTypes.number
};

export default NoSetAddressSnackbar;
